<template>
	<div>
		<div class="StyledChildWrapper-sc-1d21nde gEfhcZ">
			<label class="StyledLabel-sc-1wmcxnr enVGWB"
				><select class="StyledSelect-sc-1qmh7lk eUvvVX" @change="handleInput">
					<option v-for="(v, $v) in values" :key="$v" :value="v">{{ v }}</option></select
				><span class="StyledLabelText-sc-968s3n cfCpOb">{{ label }}</span
				><span class="StyledIconWrapper-sc-jne68a cMekVw"
					><span class="StyledIcon-sc-6xpssa dEfTaA"
						><svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
							<path d="m1.984 6.19 9.465 9.893c.28.299.418.397.551.397.145 0 .31-.114.572-.392l9.443-9.898.962.918-9.439 9.893a2.108 2.108 0 0 1-1.538.81 2.083 2.083 0 0 1-1.517-.813l-9.46-9.889z"></path></svg></span></span
			></label>
			<div class="StyledErrorText-sc-1w6zs1t cZqTKB"><div aria-live="polite" aria-relevant="additions text"></div></div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
		},
		values: {
			type: Array,
			default: [],
		},
	},
	mounted() {
		let firstValue = this.values[0]
		this.$emit("input", firstValue)
	},
	methods: {
		handleInput(e) {
			this.$emit("input", e.target.value)
		},
	},
}
</script>

<style scoped lang="scss">
.gEfhcZ {
	max-width: 100%;
}
.enVGWB {
	position: relative;
	display: block;
	color: rgb(0, 30, 80);
	padding-top: calc(16px * 1.15);
	cursor: pointer;
}
.eUvvVX {
	appearance: none;
	height: 42px;
	width: 100%;
	padding: 8px 32px 8px 0px;
	border: 0px;
	border-radius: 0px;
	box-shadow: rgb(106, 118, 125) 0px 1px 0px 0px;
	color: inherit;
	background: transparent;
	font-size: 16px;
	font-family: var(--text-regular);
	outline: none;
	cursor: pointer;
}
.cfCpOb {
	font-size: 12px;
	width: 100%;
	display: flex;
	transition: color 300ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
	pointer-events: none;
	margin: 0px;
	padding: 0px;
	position: absolute;
	top: 0px;
}
.cMekVw {
	position: absolute;
	bottom: 8px;
	display: flex;
	width: 100%;
	-webkit-box-pack: end;
	justify-content: flex-end;
	height: 24px;
	pointer-events: none;
	transition: color 300ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
	-webkit-box-align: center;
	align-items: center;
	white-space: nowrap;
}
.dEfTaA {
	position: relative;
	flex: 0 0 auto;
	overflow: visible;
	text-align: center;
	transition: color 300ms cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
	line-height: 0;
}
.dEfTaA::before {
	content: "";
	display: block;
	width: 100%;
	height: 100%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translateX(-50%) translateY(-50%);
	padding: 12px;
	border-radius: 50%;
}
.enVGWB:focus-within .StyledIconWrapper-sc-jne68a::before {
	background-color: rgb(0, 119, 204);
	content: "";
	position: absolute;
	width: 42px;
	height: 42px;
	border-radius: 999px;
	transform: translateX(9px);
	box-shadow: rgb(0, 30, 80) 0px 0px 0px 3px inset;
}
.enVGWB:focus-within .StyledIconWrapper-sc-jne68a {
	color: rgb(255, 255, 255);
}
.cZqTKB {
	display: flex;
	padding-top: 4px;
}
</style>
